module.exports = __webpack_public_path__ + "./docs/img/slots-icon-error.e91fa4f8b69dbbca7cfd2e7ec684e83c.svg";